// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fm-additions-file-list .far{padding-right:.5rem}", "",{"version":3,"sources":["webpack://./resources/js/modules/file-manager/components/modals/additions/SelectedFileList.vue"],"names":[],"mappings":"AAEI,6BACI,mBADR","sourcesContent":["\n.fm-additions-file-list {\n    .far {\n        padding-right: 0.5rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
